export const RECEIVE_ARTWORK = 'RECEIVE_ARTWORK'
export const SET_SELECTED_ARTWORK = 'SET_SELECTED_ARTWORK'
export const RESET_SELECTED_ARTWORK = 'RESET_SELECTED_ARTWORK'
export const SET_ARTWORK_FOR_MODAL = 'SELECT_ARTWORK_FOR_MODAL'


// WEBPACK FOOTER //
// ./src/constants/artwork-constants.js